import { Injectable } from "@angular/core";
import { Response, ResponseContentType } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { Constants } from "../constants/constants";
import { HttpClient } from "../authentication/httpClient";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import "rxjs/add/observable/throw";

@Injectable()
export class airQuoteHistoryService {

    constructor(private http: HttpClient) { }    

    getQuoteHistorySearch(username: string, pageNumber: number, pageSize: number, search: string): Observable<{ purchases: Array<IAirQuoteHistoryModel>, rowCount: number }> {        
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetQuoteHistory/${username}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getSavedPurchases(username: string, pageNumber: number, pageSize: number): Observable<{ purchases: Array<IAirQuoteHistoryModel>, rowCount: number }> {        
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetSavedQuotes/${username}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getSavedPurchasesSearch(purchaserEmail: string, pageNumber: number, pageSize: number): Observable<{ history: Array<IAirQuoteHistoryModel>, rowCount: number }> {        
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetSavedQuotes/${purchaserEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getCompletedQuoteHistorySearch(username: string, pageNumber: number, pageSize: number, search: string): Observable<{ purchases: Array<IAirQuoteHistoryModel>, rowCount: number }> {        
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetCompletedQuoteHistory/${username}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
    }
    

    updateQuoteStatus(approvalId: number, toFormStatusId: number, username: string): Observable<boolean> {
        return this.http.put(`${Constants.restUrl}AirQuoteHistory/UpdateQuoteStatus/${approvalId}/${toFormStatusId}/${username}`, {}).map((res: Response) => res.json()).catch(this.handleError);
    }

    // Quotes
    getQuoteHistory(username: string, pageNumber: number, pageSize: number): Observable<{ purchases: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetQuoteHistory/${username}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }


    getTrafficQuotesPending(username: string, pageNumber: number, pageSize: number): Observable<{ quotes: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetTrafficPendingQuoteSelection/${username}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getTrafficQuotesPendingSearch(username: string, pageNumber: number, pageSize: number, search: string): Observable<{ quotes: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetTrafficPendingQuoteSelection/${username}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
    }


    getTrafficPendingTrafficSelection(username: string, pageNumber: number, pageSize: number): Observable<{ quotes: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetTrafficPendingTrafficSelection/${username}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getTrafficPendingTrafficSelectionSearch(username: string, pageNumber: number, pageSize: number, search: string): Observable<{ quotes: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetTrafficPendingTrafficSelection/${username}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getTrafficCompletedQuotes(username: string, pageNumber: number, pageSize: number): Observable<{ quotes: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetTrafficCompletedQuotes/${username}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getTrafficCompletedQuotesSearch(username: string, pageNumber: number, pageSize: number, search: string): Observable<{ quotes: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetTrafficCompletedQuotes/${username}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
    }


    getQuoteById(quoteId: number): Observable<IAirQuoteHistoryModel> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetQuoteHistoryById/${quoteId}`, {}).map((res: Response) => res.json()).catch(this.handleError);
    }

    getCompletedQuoteHistory(username: string, pageNumber: number, pageSize: number): Observable<{ purchases: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetCompletedQuoteHistory/${username}/${pageNumber}/${pageSize}`, {}).map((res: Response) => res.json()).catch(this.handleError);
    }




    getManagerApprovals(managerEmail: string, pageNumber: number, pageSize: number): Observable<{ approvals: Array<IAirQuoteHistoryModel>, rowCount: number }> {           
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetManagerQuoteApprovals/${managerEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }    
    getManagerApprovalHistory(managerEmail: string, pageNumber: number, pageSize: number): Observable<{ history: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetManagerQuoteApprovalHistory/${managerEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }




    getHasManagerApprovals(managerEmail: string): Observable<boolean> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetHasManagerQuoteApprovals/${managerEmail}`).map((res: Response) => res.json()).catch(this.handleError);
    }
    getApprovingManager(quoteId: number, selectedQuoteId: number): Observable<IAirQuoteApproverModel> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetApprovingManager/${quoteId}/${selectedQuoteId}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getManagerApprovalsSearch(managerEmail: string, pageNumber: number, pageSize: number, search: string): Observable<{ approvals: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetManagerQuoteApprovals/${managerEmail}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
    }
    

    getManagerApprovalHistorySearch(managerEmail: string, pageNumber: number, pageSize: number, search: string): Observable<{ history: Array<IAirQuoteHistoryModel>, rowCount: number }> {   
        return this.http.get(`${Constants.restUrl}AirQuoteHistory/GetManagerQuoteApprovalHistory/${managerEmail}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getPurchaserApprovals(purchaserEmail: string, pageNumber: number, pageSize: number): Observable<{ approvals: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirFreightPurchaseHistory/GetPurchaserApprovals/${purchaserEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getPurchaserApprovalsSearch(purchaserEmail: string, pageNumber: number, pageSize: number, search: string): Observable<{ approvals: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirFreightPurchaseHistory/GetPurchaserApprovals/${purchaserEmail}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getPurchaserHistory(purchaserEmail: string, pageNumber: number, pageSize: number): Observable<{ history: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirFreightPurchaseHistory/GetPurchaserHistory/${purchaserEmail}/${pageNumber}/${pageSize}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getPurchaserHistorySearch(purchaserEmail: string, pageNumber: number, pageSize: number, search: string): Observable<{ history: Array<IAirQuoteHistoryModel>, rowCount: number }> {
        return this.http.get(`${Constants.restUrl}AirFreightPurchaseHistory/GetPurchaserHistory/${purchaserEmail}/${pageNumber}/${pageSize}/${search}`).map((res: Response) => res.json()).catch(this.handleError);
    }

    getPurchasers(): Observable<Array<IUserModel>> {
        return this.http.get(`${Constants.restUrl}airFreightPurchaseHistory/GetPurchasers`).map((res: Response) => res.json()).catch(this.handleError);
    }

    

   

    updatePurchaser(approvalId: number, purchaserId: number): Observable<boolean> {
        return this.http.put(`${Constants.restUrl}AirFreightPurchaseHistory/UpdatePurchaser/${approvalId}/${purchaserId}`, {}).map((res: Response) => res.json()).catch(this.handleError);
    }

    updatePurchaseItems(items: Array<IAirQuoteItemModel>): Observable<boolean> {
        return this.http.put(`${Constants.restUrl}AirFreightPurchaseHistory/UpdatePurchaseItems`, items).map((res: Response) => res.json()).catch(this.handleError);
    }

    purchaserUpdatePurchase(history: IAirQuoteHistoryModel): Observable<boolean> {
        return this.http.put(`${Constants.restUrl}AirFreightPurchaseHistory/PurchaserUpdatePurchase`, history).map((res: Response) => res.json()).catch(this.handleError);
    }

    canEditPurchase(username: string, quoteId: number): Observable<boolean> {
        return this.http.get(`${Constants.restUrl}AirFreightPurchaseHistory/CanEditPurchase/${username}/${quoteId}`, {}).map((res: Response) => res.json()).catch(this.handleError);
    }
    downloadAttachment(formTypeId: number,approvalId:number,fileName: string) {
		return this.http.get(`${Constants.restUrl}AirQuoteHistory/downloadfile/${formTypeId}/${approvalId}/${fileName}`, {
			responseType: ResponseContentType.Blob // Set response type to Blob for binary file data
		  }).map((response: Response) => response.blob());
	}

    


    private handleError(error: any): Observable<any> {
        console.error("An error occurred", error);
        return Observable.throw(error.message || error);
    }
}